/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MoleculesRouteImport } from './routes/molecules'
import { Route as IndexRouteImport } from './routes/index'

const MoleculesRoute = MoleculesRouteImport.update({
  id: '/molecules',
  path: '/molecules',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/molecules': typeof MoleculesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/molecules': typeof MoleculesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/molecules': typeof MoleculesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/molecules'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/molecules'
  id: '__root__' | '/' | '/molecules'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MoleculesRoute: typeof MoleculesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/molecules': {
      id: '/molecules'
      path: '/molecules'
      fullPath: '/molecules'
      preLoaderRoute: typeof MoleculesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MoleculesRoute: MoleculesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
